export default __webpack_public_path__ + "static/media/craon31.157695b1.jpg";